import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\CategoryController::upload
* @see app/Http/Controllers/CategoryController.php:279
* @route '/dashboard/categories/{category}/media'
*/
export const upload = (args: { category: string | number | { id: string | number } } | [category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

upload.definition = {
    methods: ["post"],
    url: '/dashboard/categories/{category}/media',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CategoryController::upload
* @see app/Http/Controllers/CategoryController.php:279
* @route '/dashboard/categories/{category}/media'
*/
upload.url = (args: { category: string | number | { id: string | number } } | [category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { category: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { category: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            category: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        category: typeof args.category === 'object'
        ? args.category.id
        : args.category,
    }

    return upload.definition.url
            .replace('{category}', parsedArgs.category.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryController::upload
* @see app/Http/Controllers/CategoryController.php:279
* @route '/dashboard/categories/{category}/media'
*/
upload.post = (args: { category: string | number | { id: string | number } } | [category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CategoryController::upload
* @see app/Http/Controllers/CategoryController.php:279
* @route '/dashboard/categories/{category}/media'
*/
const uploadForm = (args: { category: string | number | { id: string | number } } | [category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CategoryController::upload
* @see app/Http/Controllers/CategoryController.php:279
* @route '/dashboard/categories/{category}/media'
*/
uploadForm.post = (args: { category: string | number | { id: string | number } } | [category: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

upload.form = uploadForm

/**
* @see \App\Http\Controllers\CategoryController::deleteMethod
* @see app/Http/Controllers/CategoryController.php:323
* @route '/dashboard/categories/{category}/media/{mediaId}'
*/
export const deleteMethod = (args: { category: string | number | { id: string | number }, mediaId: string | number } | [category: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/dashboard/categories/{category}/media/{mediaId}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\CategoryController::deleteMethod
* @see app/Http/Controllers/CategoryController.php:323
* @route '/dashboard/categories/{category}/media/{mediaId}'
*/
deleteMethod.url = (args: { category: string | number | { id: string | number }, mediaId: string | number } | [category: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            category: args[0],
            mediaId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        category: typeof args.category === 'object'
        ? args.category.id
        : args.category,
        mediaId: args.mediaId,
    }

    return deleteMethod.definition.url
            .replace('{category}', parsedArgs.category.toString())
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CategoryController::deleteMethod
* @see app/Http/Controllers/CategoryController.php:323
* @route '/dashboard/categories/{category}/media/{mediaId}'
*/
deleteMethod.delete = (args: { category: string | number | { id: string | number }, mediaId: string | number } | [category: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\CategoryController::deleteMethod
* @see app/Http/Controllers/CategoryController.php:323
* @route '/dashboard/categories/{category}/media/{mediaId}'
*/
const deleteMethodForm = (args: { category: string | number | { id: string | number }, mediaId: string | number } | [category: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CategoryController::deleteMethod
* @see app/Http/Controllers/CategoryController.php:323
* @route '/dashboard/categories/{category}/media/{mediaId}'
*/
deleteMethodForm.delete = (args: { category: string | number | { id: string | number }, mediaId: string | number } | [category: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

const media = {
    upload: Object.assign(upload, upload),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default media